import { LocalStorageKeys } from 'app/shared/constants/localStorage';
import { LocalTableConfigType } from 'app/modules/localTableSettings/models';

export const LOCAL_TABLE_STORAGE_KEYS: Record<
  LocalTableConfigType,
  LocalStorageKeys
> = {
  [LocalTableConfigType.ASK_YOUR_ALERT_ACTION_EVENTS_TABLE]:
    LocalStorageKeys.AI_DATA_RAW_ACTION_EVENTS_TABLE_COLUMNS,
  [LocalTableConfigType.ASK_YOUR_ALERT_ENTITIES_TABLE]:
    LocalStorageKeys.AI_DATA_RAW_ENTITIES_TABLE_COLUMNS,
  [LocalTableConfigType.ASK_YOUR_ALERT_INSTRUMENTS_TABLE]:
    LocalStorageKeys.AI_DATA_RAW_INSTRUMENTS_TABLE_COLUMNS,
  [LocalTableConfigType.ASK_YOUR_ALERT_TXN_EVENTS_TABLE]:
    LocalStorageKeys.AI_DATA_RAW_TXN_EVENTS_TABLE_COLUMNS,
};
